import classNames from 'classnames';

type AddressInputProps = {
  label: string;
  error?: string;
  onChange?: (value: string) => void;
  value?: string;
};

export const AnimatedTextInput = ({
  label,
  error,
  onChange,
  value,
}: AddressInputProps): JSX.Element => (
  <div>
    <div
      className={classNames(
        'group relative rounded-md border border-cf-gray-4 bg-cf-gray-3-5 shadow-grayPop3 transition',
        'enabled:focus-within:border-cf-gray-5 enabled:focus-within:bg-cf-gray-4',
        'enabled:hover:border-cf-gray-5 enabled:hover:bg-cf-gray-4',
        'enabled:active:border-cf-gray-4 enabled:active:bg-cf-gray-3-5',
        error && 'border-cf-red-1',
      )}
    >
      <input
        data-testid={`${label}-address`}
        className="peer z-0 w-full bg-transparent p-3 text-14 text-cf-white outline-none disabled:cursor-not-allowed"
        placeholder=""
        onChange={(e) => onChange?.(e.target.value)}
        spellCheck={false}
        disabled={onChange === undefined}
        value={value}
      />
      <div
        className={classNames(
          'pointer-events-none absolute left-0 top-0 flex items-center p-3 text-14 text-cf-light-1 transition',
          'group-enabled:group-focus-within:translate-x-[-5%] group-enabled:group-focus-within:translate-y-[calc(-50%-1px)] group-enabled:group-focus-within:scale-[90%]',
          'peer-[:not(:placeholder-shown)]:translate-x-[-5%] peer-[:not(:placeholder-shown)]:translate-y-[calc(-50%-1px)] peer-[:not(:placeholder-shown)]:scale-[90%]',
        )}
      >
        <div className="flex flex-row items-center gap-1">
          <div>{label}</div>
        </div>
        <div
          className={classNames(
            // overlay red border when showing error
            'absolute inset-x-2 bottom-3 top-[49%] -z-10 bg-cf-gray-3-5',
            'transition group-enabled:group-focus-within:bg-cf-gray-4 group-enabled:group-hover:bg-cf-gray-4 group-enabled:group-active:bg-cf-gray-3-5',
          )}
        />
      </div>
    </div>
    {error && <span className="text-12 text-cf-red-1">{error}</span>}
  </div>
);
